import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { InvestmentsService } from '@app/features/main/views/investments/investment-sheet/features/investments.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'investments-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class InvestmentsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private investmentsService = inject(InvestmentsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.investmentsService.investmentAdded$,
      this.investmentsService.investmentUpdated$,
      this.investmentsService.investmentsDeleted$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.investmentsService.loadInvestmentsPage(selectParams)
      .pipe(first(), map(investments => investments.first()));
  }
}
